const initialState = {
  test: 1,
};

const MainReducers = (state = initialState, action) => {
  switch (action.type) {
    case 'TEST':
      return {
        ...state,
        test: state.test++,
      };

    default:
      return {
        ...state,
      };
  }
};

export default MainReducers;
